class BreweryModals {
    constructor() {
        this.brewerEls = Array.from(document.querySelectorAll('[data-ui-element="brewer"]'));

        this.modal = document.querySelector('[data-ui-modal="brewer-modal"]');
        this.escapeKeyCode = 27;

        if (this.brewerEls && this.modal) {
            this.bindEvents();
        }
    }

    bindEvents() {
        this.brewerEls.forEach((brewerEl) => {
            brewerEl.addEventListener('click', () => this.loadBrewerModal(brewerEl));
        });

        this.modal.addEventListener('click', (e) => {
            if (e.target == this.modal) {
                this.close();
            }
        });
        
        const modalClose = this.modal.querySelector('[data-ui-modal="close"]');
        modalClose.addEventListener('click', (e) => {
            e.preventDefault();
            this.close();
        });

        window.addEventListener('keyup', (e) => {
            if (e.keyCode === this.escapeKeyCode) {
                this.close();
            }
        });
    }

    loadBrewerModal(brewerEl) {
        const brewerModalBox = this.modal.querySelector('.modal-box');
        brewerModalBox.innerHTML = brewerEl.innerHTML;

        this.modal.classList.add('open');
    }

    close() {
        this.modal.classList.remove('open');
    }
}

export default new BreweryModals();



// WEBPACK FOOTER //
// ./src/js/modules/modals/brewery-modals.js